import React from "react";

const AddRoomBtn = ({ values, onClick, rooms }) => {
  
  const isDateMissing = !values.checkin_date || !values.checkout_date;
  
  const isRoomIncomplete = rooms.some(room => !room.room_type_id || !room.room_id);

  const isDisabled = isDateMissing || isRoomIncomplete;

  const title = isDateMissing
    ? "Select check-in & check-out dates first"
    : isRoomIncomplete
      ? "Complete current room selection before adding another"
      : "Add another room";

  return (
    <button
      type="button"
      onClick={onClick}
      className="btn btn-sm btn-primary mt-auto"
      disabled={isDisabled}
      title={title}
      aria-label="Add Room"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="svg-stroke"
      >
        <path stroke="none" d="M0 0h24v24H0z" />
        <path d="M12 5l0 14" />
        <path d="M5 12l14 0" />
      </svg>
    </button>
  );
};

export default AddRoomBtn;
